import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';



@Component({
  selector: 'app-dynamic-select-input',
  templateUrl: './dynamic-select-input.component.html',
  styleUrls: ['./dynamic-select-input.component.scss', '../../../../assets/sass/libs/select.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicSelectInputComponent implements OnInit{

  @Input() itemsList: any[]= [];
  // El componente sirve los dos modos: con [multiple]="true" ng-select trabaja con un array
  // y con [multiple]="false" con el bindValue suelto. Tiparlo solo como string[] era mentira
  // y obligaba a los llamantes de un solo valor a pasar algo que ng-select no sabe resolver.
  @Input() selectedItems:string[] | string;
  
  @Input() siteId: string;
  @Input() label?:string;
  @Input() linkLabel?:string="";
  @Input() type:string;
  @Input() searchText:string;
  
  @Input() multiple:boolean = false;
  @Input() defaultBindLabel:any;
  @Input() hasTag?:boolean;
  @Input() pillClassMap?: Record<string, string>;
  @Input() showCloseButton?:boolean = true;
  @Input() hasIcon?:boolean;
  @Input() placeholder?:string;
  @Input() bindId?:string = "id";
  @Input() maxSelected?:number;
  @Input() hasEmoji?:Boolean = false;
  @Input() hasSymbol:Boolean = false;
  @Input() hasMenu:Boolean = false;
  @Input() hasFilter:Boolean = false;
  @Input() disable:Boolean = false;
  @Input() notFoundText?:string;
  @Input() clearSearchOnAdd: boolean = false;
  @Input() dropdownPosition: 'auto' | 'top' | 'bottom' = 'bottom';
  @Input() hasPhoneCode: boolean = false;
  @Input() showAsterisk: boolean = false;
  /**
   * Modo "thumbnail + título": pinta un icono redondo (campo `iconUrl` del item, con placeholder
   * si falta o falla la imagen) junto al título, tanto en las opciones como en el tag seleccionado.
   * Usado por los combos de categorías (producto y padre de categoría).
   */
  @Input() hasThumb: boolean = false;
  
  @Output() newIunputEvent = new EventEmitter<string>();
  @Output() newSelectEvent = new EventEmitter<string>();
  @Output() newNavEvent = new EventEmitter<string>();
  @Output() closeMenuEvent = new EventEmitter<string>();

  constructor() { 
  }
  
  ngOnInit(): void {
    //console.log("on dynamic select init")
    //console.log(this.itemsList);
    //console.log(this.selectedItems);
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log("on dynamic select changes");
    //console.log(changes);
    //console.log(this.itemsList);
    //console.log(this.selectedItems);
    //this.itemsList.slice();
    //this.selectedItems.slice();
  }

 
  onSearchInput(event){
    this.newIunputEvent.emit(event.term);
  }

  onSelectItem(event){
    //if(this.itemsList)
   // console.log("on select item from dynamic input 000000000");
   // console.log(event);
    this.newSelectEvent.emit(event);
    //this.itemsList = this.itemsList.slice();
    /*let index = this.itemsList.findIndex(x=> x.id === event.id)
    if(this.itemsList[index].disabled){
      this.itemsList[index].disabled = true;
      console.log("on select item from dynamic input");
    }*/
   /* if (this.multiple) {
      this.selectedItems.slice();
    }*/
  }

  onClickLinkLabel(event){
    this.newNavEvent.emit(event);
    this.selectedItems.slice();
  }

  isSelected(id:string){
    return this.selectedItems.indexOf(id) != -1;
  }

  onCloseMenu(event){
    //console.log("on close menu event ");
    //console.log(event);
    if(this.multiple){
      this.closeMenuEvent.emit();
    }
    }

  // Custom search function for currencies - searches by name instead of code
  currencySearchFn = (term: string, item: any) => {
    term = term.toLowerCase();
    // Search in the currency name (label.default_value)
    const nameMatch = item.label?.default_value?.toLowerCase().includes(term);
    // Also search in code as fallback
    const codeMatch = item.code?.toLowerCase().includes(term);
    // Also search in symbol
    const symbolMatch = item.symbol?.toLowerCase().includes(term);
    return nameMatch || codeMatch || symbolMatch;
  };

  // Compare function for ng-select to handle object vs string comparison
  compareWithFn = (a: any, b: any): boolean => {
    // If both are the same reference or equal primitives
    if (a === b) return true;
    // If either is null/undefined
    if (!a || !b) return false;
    // Get the ID from each (could be object with id property or primitive)
    const aId = typeof a === 'object' ? a[this.bindId] : a;
    const bId = typeof b === 'object' ? b[this.bindId] : b;
    return aId === bId;
  };

  //==================== Modo hasThumb (thumbnail + título) ====================//
  // URLs de icono cuyo fichero ya no existe; se indexa por URL (no por item) para que la marca
  // sobreviva a reconstrucciones de la lista de opciones. Igual criterio que el árbol/producto.
  private readonly brokenThumbUrls = new Set<string>();

  /** URL del thumbnail del item, o undefined si no tiene o si el fichero ya no existe (→ placeholder). */
  getThumbUrl(item: any): string | undefined {
    const url = item?.iconUrl;
    if (!url || this.brokenThumbUrls.has(url)) {
      return undefined;
    }
    return url;
  }

  /** Marca la URL como rota para caer al placeholder sin reintentar (evita bucle de carga). */
  onThumbError(item: any): void {
    const url = item?.iconUrl;
    if (url) {
      this.brokenThumbUrls.add(url);
    }
  }
}
